module.exports = __webpack_public_path__ + "img/agentAndVideo.6e016510.svg";